module.exports = __webpack_public_path__ + "static/vib_play2s-e8befae4e77ba92c13017c82bf906f60.jpg";